import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/storefront/components/StockistEmbed/index.js");
